import { createAsyncThunk } from "@reduxjs/toolkit";
import { PostVouchersAssignPromocodeByEmailParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const postVouchersAssignPromocodeByEmail = createAsyncThunk<
  void,
  PostVouchersAssignPromocodeByEmailParams
>(
  "vouchers/postVouchersAssignPromocodeByEmail",
  async (params, { rejectWithValue }) => {
    try {
      await VouchersAPI.postVouchersAssignPromocodeByEmail(params);
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while assigning promocode by email",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while assigning promocode by email", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
